module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/3.1-account-password.a256ffc4.png";